import Swal from 'sweetalert2';

export const alert = (config) => {
    return Swal.fire(config);
};
